import React from 'react';
import { Outlet } from 'react-router-dom';
import Logo from '../assets/images/auth/ryno-logo-white.png';
import Collaboration from '../assets/images/auth/collaboration.png';
import Dashboard from '../assets/images/auth/signup-dashboard-excerpts.png';
import VectorBG from '../assets/images/auth/ryno-vector-bg.png';
import BaseImage from '../components/base/base-image';

interface IAuthLayoutProps {
  pageType: 'login' | 'signup';
}

const AuthLayout: React.FC<IAuthLayoutProps> = ({ pageType }) => {
  return (
    <div
      className={`flex flex-col md:flex-row w-full h-screen ${
        pageType === 'signup' ? 'md:flex-row-reverse' : ''
      }`}
    >
      {pageType === 'login' ? (
        <aside className="hidden md:flex flex-col h-screen w-full md:w-1/2">
          <div className="h-2/3 relative">
            <BaseImage
              imgSrc={Collaboration}
              imgAlt="Collaboration"
              imgClass="w-5/6 absolute bottom-0 left-1/2 transform -translate-x-1/2"
            />
          </div>
          <div className="bg-primary h-1/3 flex flex-col text-white py-8 px-12 2xl:p-12">
            <BaseImage imgSrc={Logo} imgAlt="Logo" imgClass="w-24 mb-6" />
            <h1 className="2xl:text-4xl text-2xl font-semibold w-[80%] mb-4">
              Your global partner for seamless international payments and
              currency exchange...
            </h1>
            <p className="md:w-[80%]">
              Join us and experience top-tier service and expertise.
            </p>
          </div>
        </aside>
      ) : (
        <aside className="hidden overflow-y-hidden md:flex flex-col h-screen w-full md:w-1/2 bg-primary text-white pl-24 relative">
          <BaseImage
            imgSrc={VectorBG}
            imgAlt="BG"
            imgClass="absolute left-0 top-0 z-0"
          />
          <div className="z-10">
            <h1 className="text-4xl font-semibold w-[80%] mb-4 mt-12">
              Welcome to ryno!
            </h1>
            <p className="md:w-[80%]">
              Your global partner for seamless international payments and
              currency exchange...Join us and experience top-tier service and
              expertise.
            </p>

            <div className="mt-16">
              <BaseImage
                imgSrc={Dashboard}
                imgAlt="Dashboard"
                imgClass="rounded-tl-2xl"
              />
            </div>
          </div>
        </aside>
      )}

      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default AuthLayout;
